import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class MotivoRegistroValidation extends DefaultValidation {
	validate(model, permissao, refs) {
		let validated = true;

		/**
		 * contato
			observacao
			qtdeminimafoto
		 */

		if (Util.isNull(model.idmotivo)) {
			refs.motivoSelect.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.descricao)) {
			refs.descricaoInput.focusedOut = true;
			validated = false;
		}
		if (permissao.contato==2&&Util.isNull(model.contato)) {
			refs.contatoInput.focusedOut = true;
			validated = false;
		}
		if (permissao.observacao==2&&Util.isNull(model.observacao)) {
			refs.observacaoTextarea.focusedOut = true;
			validated = false;
		}
		if (permissao.qtdeminimafoto>model.motivoregistrofoto.length) {
			refs.observacaoTextarea.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}